import { defaultFilter } from '@components/Table/table.utils';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/pivot/')({
  validateSearch: zodValidator(withDefaults(schema.PIVOT, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
